import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import MaterialTextField from 'material-ui/TextField/TextField';
import { Card, CardActions } from "material-ui/Card";
import { NavigationArrowBack } from "material-ui/svg-icons";
import connect from "react-redux/es/connect/connect";
import dayjs from "dayjs";

import * as utils from './utils';
import * as urls from "./urls";
import ViewTitle from "components/layout/ViewTitle";
import { TextInput, BooleanInput } from "components/input";
import {
  getEpaymentServiceTerminalId as getEpaymentServiceTerminalIdAction,
  updateSetupRequest as updateSetupRequestAction,
} from "actions/e_payment";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};

class SetupRequestEdit extends Component {
  state = {};

  componentDidMount() {
    const {record} = this.props;
    if (!record || !record.epayment_settings) {
      this.goBack();
      return;
    }
    this.props.dispatch(getEpaymentServiceTerminalIdAction(record.shop_id));

    let initialState = {
      epayment_settings: {},
      errors: {},
      airpay_euid: "",
    };
    for (const setting of record.epayment_settings) {
      initialState.epayment_settings[setting.epayment_service] = {terminal_id: "", ...setting};
      initialState.errors[setting.epayment_service] = {};
    }
    this.setState(initialState);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      nextProps.service_terminal_ids
      && nextProps.service_terminal_ids.length > 0
    ) {
      const newState = {...this.state};
      for (const service_terminal_id of nextProps.service_terminal_ids) {
        newState.epayment_settings[service_terminal_id.epayment_service] = {
          ...newState.epayment_settings[service_terminal_id.epayment_service],
          terminal_id: service_terminal_id.terminal_id,
        };
        newState.airpay_euid = service_terminal_id.airpay_euid;
      }
      this.setState(newState);
    }
  }

  goBack = () => {
    this.props.history.push(urls.setupRequestFrontendPath);
  }

  onSettingDataChange = (service_code, field, value) => {
    this.setState((state) => {
      return {
        ...state,
        epayment_settings: {
          ...state.epayment_settings,
          [service_code]: {
            ...state.epayment_settings[service_code],
            [field]: value,
          },
        },
      };
    });
  };

  getSetting = (record, service_code) => {
    for (const setting of record.epayment_settings) {
      if (setting.epayment_service === service_code) {
        return setting;
      }
    }
    return null;
  };

  checkError = () => {
    const {record} = this.props;

    const errorState = {};
    let isHaveError = false;
    for (const setting of record.epayment_settings) {
      const newSetting = this.state.epayment_settings[setting.epayment_service];
      if (
        setting.service_enabled
        && !newSetting.service_enabled && newSetting.note.trim() === ''
      ) {
        errorState[setting.epayment_service] = {
          note: "This field is require",
          ...errorState[setting.epayment_service]
        };
        isHaveError = true;
      }
      if (
        newSetting.epayment_service !== utils.EPAYMENT_SERVICE_AIRPAY
        && !setting.service_enabled
        && newSetting.service_enabled
        && newSetting.terminal_id.trim() === ''
      ) {
        errorState[setting.epayment_service] = {
          terminal_id: "This field is require",
          ...errorState[setting.epayment_service]
        };
        isHaveError = true;
      }
    }

    this.setState({
      ...this.state,
      errors: errorState,
    });
    return isHaveError;
  };

  handleUpdate = () => {
    const {record} = this.props;
    if (this.checkError()) {
      return;
    }

    const {epayment_settings} = this.state;
    const data = {
      shop_id: record.shop_id,
      epayment_settings: Object.keys(epayment_settings).map((k) => {
        const epayment_setting = {...epayment_settings[k]};
        if (epayment_setting.terminal_id.trim() === "") {
          delete epayment_setting.terminal_id
        }
        if (epayment_setting.note.trim() === "") {
          delete epayment_setting.note
        }
        return epayment_setting;
      }),
    };
    this.props.dispatch(updateSetupRequestAction(data));
  };

  render() {
    const {record} = this.props;

    if (!record || !record.epayment_settings) {
      return (
        <Redirect to={urls.setupRequestFrontendPath}/>
      );
    }
    if (!this.state.epayment_settings) {
      return null;
    }

    return (
      <div className="list-page">
        <Card style={{padding: '5px'}}>
          <CardActions style={cardActionStyle}>
            <FlatButton
              primary label={'Back'}
              onClick={this.goBack}
              icon={<NavigationArrowBack/>}
            />
          </CardActions>
          <ViewTitle title='E-Payment Setup Request'/>

          <div style={{padding: '20px'}}>
            <MaterialTextField
              disabled={true}
              floatingLabelText={'Shop ID'}
              value={record.shop_id}
            />
            <br/>
            <MaterialTextField
              disabled={true}
              floatingLabelText={'AirPay linked'}
              value={record.airpay_linking_status === utils.AIRPAY_MERCHANT_LINKING_LINKED ? "Yes" : "No"}
            />
            <br/>
            <MaterialTextField
              disabled={true}
              floatingLabelText={'AirPay first linked on'}
              value={record.airpay_linked_on ? dayjs(record.airpay_linked_on).format('YYYY-MM-DD hh:mm:ss') : ""}
            />
            <br/>
            <MaterialTextField disabled={true} floatingLabelText={'AirPay EUID'} value={this.state.airpay_euid}/>
            <br/>

            {record.epayment_settings.map((setting) => {
              return (
                <div key={setting.epayment_service}>

                  <BooleanInput
                    label={`${utils.EPAYMENT_SERVICE_CODE_NAME_MAP[setting.epayment_service]} Enabled`}
                    input={{
                      onChange: (event, value) => {
                        this.onSettingDataChange(setting.epayment_service, 'service_enabled', value);
                      },
                      value: this.state.epayment_settings[setting.epayment_service].service_enabled,
                    }}
                  />
                  <br/>

                  {setting.epayment_service !== utils.EPAYMENT_SERVICE_AIRPAY && (
                    <div>
                      <TextInput
                        label={`${utils.EPAYMENT_SERVICE_CODE_NAME_MAP[setting.epayment_service]} Terminal ID`}
                        isRequired={!setting.service_enabled && this.state.epayment_settings[setting.epayment_service].service_enabled}
                        input={{
                          onChange: (event) => {
                            this.onSettingDataChange(setting.epayment_service, 'terminal_id', event.target.value);
                          },
                          value: this.state.epayment_settings[setting.epayment_service].terminal_id,
                          onBlur: () => {
                          },
                          onFocus: () => {
                          },
                        }}
                        meta={{
                          error: this.state.errors[setting.epayment_service] ? this.state.errors[setting.epayment_service].terminal_id : "",
                          touched: true,
                        }}
                      />
                      <br/>
                    </div>
                  )}

                  {!this.state.epayment_settings[setting.epayment_service].service_enabled && (
                    <div>
                      <TextInput
                        label={`${utils.EPAYMENT_SERVICE_CODE_NAME_MAP[setting.epayment_service]} Disable Reason`}
                        isRequired={this.getSetting(this.props.record, setting.epayment_service).service_enabled}
                        input={{
                          onChange: (event) => {
                            this.onSettingDataChange(setting.epayment_service, 'note', event.target.value);
                          },
                          value: this.state.epayment_settings[setting.epayment_service].note,
                          onBlur: () => {
                          },
                          onFocus: () => {
                          },
                        }}
                        meta={{
                          error: this.state.errors[setting.epayment_service] ? this.state.errors[setting.epayment_service].note : "",
                          touched: true,
                        }}
                      />
                      <br/>
                    </div>
                  )}
                </div>
              );
            })}

            <FlatButton
              primary label='Update'
              style={{
                margin: '5px 12px',
                position: 'relative',
              }}
              onClick={this.handleUpdate}
            />
          </div>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    record: state.admin.recordSelected[utils.setupRequestResourceName],
    service_terminal_ids: state.admin.e_payment.service_terminal_ids || [],
  };
}

export default connect(mapStateToProps)(SetupRequestEdit);



// WEBPACK FOOTER //
// ./src/routes/e_payment/SetupRequestEdit.js